import Vue from 'vue'
import Router from 'vue-router'
import oidcCallback from '@/components/common/oidcCallback'
import {vuexOidcCreateRouterMiddleware} from 'vuex-oidc'
import store from '../store'

var terminal = "workflow";
if (getMobile()) terminal = "wechat";

Vue.use(Router);

Vue.prototype.$global = () => {
    return {
        terminal
    }
}

var router = new Router({
    mode: "history", // 加上history之后本地build之后router不正常显示，所以先暂时注释
    base: window.commonApi.PATH ? window.commonApi.PATH : '/',
    routes: [
        {
            path: '/',
            redirect: '/workflow/index'
        },
        {
            path: '/workflow/index',
            name: 'apps',
            component: resolve => require([`@/views/todoCenter/default/${terminal}/contentsIndexTemplate`], resolve)
        },
        {
            path: '/workflow/servicecenter',
            name: 'serviceC',
            meta: {
                isPublic: false,
            },
            component: resolve => require([`@/views/todoCenter/default/${terminal}/contentsServiceCenterTemplate`], resolve)
        },
        {
            path: '/workflow/ztdetail',
            name: 'zt',
            meta: {
                isPublic: false,
            },
            component: resolve => require([`@/views/todoCenter/default/${terminal}/contentsZtDetailTemplate`], resolve)
        },
        {
            path: '/workflow/todo',
            name: 'todo',
            component: resolve => require([`@/views/todoCenter/default/${terminal}/contentsTodoTemplate`], resolve)
        },
        {
            path: '/workflow/doing',
            name: 'doing',
            component: resolve => require([`@/views/todoCenter/default/${terminal}/contentsDoingTemplate`], resolve)
        },
        {
            path: '/workflow/done',
            name: 'done',
            component: resolve => require([`@/views/todoCenter/default/${terminal}/contentsDoneTemplate`], resolve)
        },
        {
            path: '/workflow/flow_cc',
            name: 'flow_cc',
            component: resolve => require([`@/views/todoCenter/default/${terminal}/contentsCcTemplate`], resolve)
        },
        {
            path: '/workflow/favorite',
            name: 'favorite',
            component: resolve => require([`@/views/todoCenter/default/${terminal}/contentsFavoriteTemplate`], resolve)
        },
        {
            path: '/workflow/detail',
            name: 'detail',
            component: resolve => require([`@/views/todoCenter/default/${terminal}/contentsItemDetail`], resolve)
        },
        {
            path: '/workflow/guide/:id',
            name: 'guide',
            component: resolve => require([`@/views/todoCenter/default/${terminal}/contentsGuideTemplate`], resolve)
        },
        {
            path: '/workflow/help',
            name: 'help',
            component: resolve => require([`@/views/todoCenter/default/${terminal}/contentsHelpCenterTemplate`], resolve)
        },
        {
            path: '/workflow/inventory',
            name: 'inventory',
            component: resolve => require([`@/views/todoCenter/default/${terminal}/contentsServiceInventoryTemplate`], resolve)
        },
        {
            path: '/workflow/oidcCallback',
            name: 'oidcCallback',
            component: oidcCallback,
            meta: {
                isVuexOidcCallback: true,
                isPublic: true
            }
        },
        {
            path: '/signin-oidc-error',
            redirect: '/'
        }
    ]
})

function getMobile() {
    var flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (flag === null) {
        return false;
    } else {
        return true;
    }
}

router.beforeEach(vuexOidcCreateRouterMiddleware(store, 'oidcStore'));
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js